var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, Grid, Icon, Input, Loader, Menu, Message, Modal, Pagination, Table } from "semantic-ui-react";
import { debounce } from "../kit/rna-cish/ProKitForm";
import { Accession } from "../kit/rna-cish/RnaCatalog";
import { accessionSearchLink, compactRnaCishAccessionsListWithPopup, rnaModal } from "../kit/rna-fish/KitDisplay";
import { getWithAuthn } from "../RequestHelpers";
import AddUserAmplifierConfigModal from "./AddUserAmplifierConfigModal";
import ChangeUserAmplifierConfigVisibilityModal from "./ChangeUserAmplifierConfigVisibilityModal";
import { synonymsPopup } from "./RnaCatalogPage";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
var RnaCatalogTablePage = /** @class */ (function (_super) {
    __extends(RnaCatalogTablePage, _super);
    function RnaCatalogTablePage(props) {
        return _super.call(this, props) || this;
    }
    RnaCatalogTablePage.prototype.render = function () {
        return React.createElement(CatalogTablePageContent, null);
    };
    return RnaCatalogTablePage;
}(React.Component));
export default RnaCatalogTablePage;
var CatalogTablePageContent = /** @class */ (function (_super) {
    __extends(CatalogTablePageContent, _super);
    function CatalogTablePageContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCatalog = function (catalog) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Organism"),
                        React.createElement(Table.HeaderCell, null, "Scientific Name"),
                        React.createElement(Table.HeaderCell, null, "Gene Symbol"),
                        React.createElement(Table.HeaderCell, null, "Accession #'s"),
                        React.createElement(Table.HeaderCell, null, "Synonyms"),
                        React.createElement(Table.HeaderCell, null, "Probe size"),
                        React.createElement(Table.HeaderCell, null, "Variant"),
                        React.createElement(Table.HeaderCell, null, "Variant Target RNA Sequence"),
                        React.createElement(Table.HeaderCell, null, "Variant Target Accession #"),
                        React.createElement(Table.HeaderCell, null, "Validated"))),
                React.createElement(Table.Body, null, catalog.organisms.flatMap(function (org, orgIndex) {
                    return org.probeSetFamilies.flatMap(function (psf, psfIndex) {
                        return psf.variants.flatMap(function (variant, variantIndex) {
                            var _a;
                            return React.createElement("tr", { key: orgIndex + "-" + psfIndex + "-" + variantIndex },
                                React.createElement(Table.Cell, null, org.name),
                                React.createElement(Table.Cell, null, org.scientificName),
                                React.createElement(Table.Cell, null, psf.geneSymbol),
                                React.createElement(Table.Cell, null, compactRnaCishAccessionsListWithPopup(psf.accessions.map(function (a) {
                                    return new Accession(a.id, a.transcriptAccession, a.accessionType, a.transcriptLength, a.transcriptName);
                                }).sort(function (a, b) {
                                    return a.transcriptAccession.localeCompare(b.transcriptAccession);
                                }))),
                                React.createElement(Table.Cell, null, compactSynonymsListForPopup(psf.synonyms)),
                                React.createElement(Table.Cell, null, variant.probeSetSize),
                                React.createElement(Table.Cell, null, variant.name),
                                React.createElement(Table.Cell, null, rnaModal(variant.targetMrnaSeq, "Variant Rna Seq.")),
                                React.createElement(Table.Cell, null, ((_a = psf.accessions
                                    .find(function (a) { return a.id === variant.accessionId; })) === null || _a === void 0 ? void 0 : _a.transcriptAccession) ?
                                    accessionSearchLink(psf.accessions.find(function (a) { return a.id === variant.accessionId; }).transcriptAccession) : ""),
                                React.createElement(Table.Cell, null, variant.validated));
                        });
                    });
                })));
        };
        _this.renderChromogenAndUserAmplifierConfigTable = function (catalog) {
            var renderAddUserAmplifierConfig = function (props) {
                return React.createElement(AddUserAmplifierConfigModal, __assign({}, props));
            };
            var renderChangeConfigVisibilityModal = function (configId, targetVisibility) {
                return function (props) {
                    return React.createElement(ChangeUserAmplifierConfigVisibilityModal, __assign({ configId: configId, targetVisibility: targetVisibility }, props));
                };
            };
            return React.createElement(Grid, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus', label: 'Add User Amplifier Config', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Add User Amplifier Config"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderAddUserAmplifierConfig, successMessage: 'User Amplifier Config added' }))),
                    React.createElement("h1", null, "Current User Amplifier Catalog"),
                    React.createElement(Table, { striped: true },
                        React.createElement(Table.Header, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.HeaderCell, null, "Configuration Id"),
                                React.createElement(Table.HeaderCell, null, "Protocol Type"),
                                React.createElement(Table.HeaderCell, null, "Display Name"),
                                React.createElement(Table.HeaderCell, null, "Amplifier"),
                                React.createElement(Table.HeaderCell, null, "Hapten"),
                                React.createElement(Table.HeaderCell, null, "Anti-Hapten 1"),
                                React.createElement(Table.HeaderCell, null, "Hapten conjugated to tyramide"),
                                React.createElement(Table.HeaderCell, null, "Anti-Hapten 2 Ap"),
                                React.createElement(Table.HeaderCell, null, "Anti-Hapten 2 Hrp"),
                                React.createElement(Table.HeaderCell, null, "Visible"))),
                        React.createElement(Table.Body, null, catalog.cishUserAmplifierCatalog.map(function (u, index) {
                            var _a, _b;
                            return React.createElement("tr", { key: "" + index },
                                React.createElement(Table.Cell, null, u.id),
                                React.createElement(Table.Cell, null, u.protocolType.label),
                                React.createElement(Table.Cell, null, u.displayName),
                                React.createElement(Table.Cell, null, u.amplifier.id),
                                React.createElement(Table.Cell, null, u.hapten),
                                React.createElement(Table.Cell, null, u.antiHapten1.label),
                                React.createElement(Table.Cell, null, u.tyramideHapten.label),
                                React.createElement(Table.Cell, null, (_a = u === null || u === void 0 ? void 0 : u.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.label),
                                React.createElement(Table.Cell, null, (_b = u === null || u === void 0 ? void 0 : u.antiHapten2Hrp) === null || _b === void 0 ? void 0 : _b.label),
                                React.createElement(Table.Cell, null,
                                    u.visible ? React.createElement(Icon, { name: 'check' }) : React.createElement(Icon, { name: 'x' }),
                                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: u.visible ? 'eye' : 'eye slash', label: u.visible ? 'Make Invisible' : 'Make Visible', labelPosition: 'left' }) },
                                        React.createElement(Modal.Header, null, "Change Visibility"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeConfigVisibilityModal(u.id, !u.visible), successMessage: 'Visibility changed' })))));
                        })))));
        };
        _this.onPageChange = function (_, data) {
            var path = "/admin/catalog/rna/paged/full?pageNumber=" + encodeURIComponent(data.activePage - 1);
            if (_this.state.orgFilter !== "") {
                path = path + ("&organismFilter=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.targetFilter !== "") {
                path = path + ("&probeSetFamilyFilter=" + encodeURIComponent(_this.state.targetFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            catalog: resp.catalog,
                            currentPage: data.activePage,
                            totalPages: resp.catalog.totalPages
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load catalog: " + rej);
                });
            });
        };
        _this.onOrganismFilterChange = function (event, data) {
            var str = data.value;
            _this.setState(function () {
                return {
                    orgFilter: str,
                    currentPage: 1,
                };
            }, _this.loadCurrentCatalogPage);
        };
        _this.onTargetFilterChange = function (event, data) {
            _this.setState(function () {
                return {
                    targetFilter: data.value,
                    currentPage: 1,
                };
            }, _this.loadCurrentCatalogPage);
        };
        _this.loadCurrentCatalogPage = function () {
            var path = "/admin/catalog/rna/paged/full?pageNumber=" + encodeURIComponent(_this.state.currentPage - 1);
            if (_this.state.orgFilter !== "") {
                path = path + ("&organismFilter=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.targetFilter !== "") {
                path = path + ("&probeSetFamilyFilter=" + encodeURIComponent(_this.state.targetFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            catalog: resp.catalog,
                            totalPages: resp.catalog.totalPages
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load catalog: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            orgFilter: '',
            targetFilter: '',
            currentPage: 1,
            totalPages: 0
        };
        return _this;
    }
    CatalogTablePageContent.prototype.componentDidMount = function () {
        this.loadCurrentCatalogPage();
    };
    CatalogTablePageContent.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Catalog could not be loaded."),
                React.createElement(Menu, null,
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onOrganismFilterChange, 300), placeholder: 'Chupacabra' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onTargetFilterChange, 300), type: 'text', placeholder: 'Filter Probe Set Family' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Pagination, { totalPages: this.state.totalPages, ellipsisItem: null, onPageChange: this.onPageChange, activePage: this.state.currentPage }))),
                this.state.catalog &&
                    React.createElement("div", null,
                        React.createElement("div", { className: "catalog" }, this.renderCatalog(this.state.catalog)),
                        React.createElement("br", null),
                        React.createElement("div", { className: "catalog" }, this.renderChromogenAndUserAmplifierConfigTable(this.state.catalog)))));
    };
    return CatalogTablePageContent;
}(React.Component));
export var compactSynonymsListForPopup = function (synonyms) {
    if (synonyms.length === 0) {
        return 'None';
    }
    else if (synonyms.length === 1) {
        return synonyms[0];
    }
    else {
        return React.createElement(React.Fragment, null,
            synonyms[0],
            ", \u2026 ",
            synonymsPopup(synonyms));
    }
};
//# sourceMappingURL=RnaCatalogTablePage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/RnaCatalogTablePage.js
// module id = 1327
// module chunks = 0